<template>
  <b-modal
    size="sm"
    button-size="sm"
    v-model="showModal"
    :title="title"
    hide-footer
    @hidden="cancelar"
  >
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-const-select
              v-model="form.tipoTelefone"
              label="Tipo de Telefone: *"
              :options="optionsTipoTelefone"
              required
            ></lg-form-const-select>

            <lg-form-input
              v-model="form.dddTelefone"
              label="DDD: *"
              required
              :formatter="formatarDDD"
            ></lg-form-input>

            <lg-form-input
              v-model="form.numeroTelefone"
              label="Número de Telefone: *"
              required
              :formatter="formatarNumeroTelefone"
            ></lg-form-input>

            <b-form-group label-for="principal" class="col-12">
              <b-form-checkbox id="principal" v-model="form.principal"
                >Principal</b-form-checkbox
              >
            </b-form-group>

            <b-form-radio-group
              size="sm"
              v-model="form.situacaoTelefone"
              :options="optionsSituacao"
              name="situacao-options"
              class="d-flex col-12"
            >
            </b-form-radio-group>
            <div class="d-flex justify-content-center mt-3">
              <b-button
                type="submit"
                variant="success"
                style="height: 30px"
                pill
                size="sm"
              >
                <div>
                  <b-icon icon="check-circle" />
                </div>
              </b-button>
              <b-button
                class="ml-2"
                @click="cancelar"
                style="height: 30px"
                pill
                size="sm"
                variant="danger"
              >
                <div>
                  <b-icon icon="x-circle" />
                </div>
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import API from "@/core/api/index";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
  },
  data() {
    return {
      showModal: true,
      optionsTipoTelefone: [],
      optionsSituacao: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],
      form: {
        tipoTelefone: null,
        principal: true,
        dddTelefone: "",
        numeroTelefone: "",
        situacaoTelefone: 1,
        codEmpresa: this.codEmpresa,
      },
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/telefone`);
    API.get(`/api/telefone/tipos`).then((response) => {
      this.optionsTipoTelefone = [
        { text: "Selecione...", value: null },
        ...response.data.map((item) => ({
          text: item.descTipoTelefone,
          value: item,
        })),
      ];
    });

    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
      this.form.codEmpresa = this.codEmpresa;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    formatarDDD(value) {
      return value.replace(/\D/g, "").slice(0, 2);
    },
    formatarNumeroTelefone(value) {
      let cleanedValue = value.replace(/[^\d]/g, "");
      if (cleanedValue.length > 9) {
        cleanedValue = cleanedValue.slice(0, 9);
      }
      return cleanedValue;
    },
    async submitForm() {
      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Este registro já está cadastrado'
        });
        return;
      }

    },
    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style scoped>
.btn-size-alinhamento {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
